import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { HttpClientModule } from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RouterModule, Routes } from '@angular/router';
import { MatMomentDateModule } from '@angular/material-moment-adapter';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { TranslateModule } from '@ngx-translate/core';
import 'hammerjs';

import { FuseModule } from '@fuse/fuse.module';
import { FuseSharedModule } from '@fuse/shared.module';
import { FuseProgressBarModule, FuseSidebarModule, FuseThemeOptionsModule } from '@fuse/components';

import { fuseConfig } from 'app/fuse-config';

import { HTTP_INTERCEPTORS } from '@angular/common/http';

import { TokenInterceptor } from '@fuse/services/auth/token.interceptor';
import { AuthService } from '@fuse/services/auth/auth.service';
import { AuthGuardService as AuthGuard } from '@fuse/services/auth/auth-guard.service';
import { RoleGuardService as RoleGuard } from '@fuse/services/auth/role-guard.service';
import { JwtInterceptor } from '@fuse/services/auth/jwt.interceptor';

import { AppComponent } from 'app/app.component';
import { LayoutModule } from 'app/layout/layout.module';

import { AuthModule } from './main/auth/auth.module';

import { SocialLoginModule, AuthServiceConfig } from 'angularx-social-login';
import { GoogleLoginProvider, FacebookLoginProvider } from 'angularx-social-login';

import { NotificationsManagementModule } from './main/notifications/notifications-management.module';
import { FaqModule } from './main/faq/faq.module';
import { AdsModule } from './main/ads/ads.module';
import { RequestManagementModule } from './main/request/request-management.module';
import { RecommenderManagementModule } from './main/recommender/recommender-management.module';
import { DownloadManagementModule } from './main/download/download-management.module';
import { SampleModule } from './main/sample/sample.module';
import { ProjectComponent } from './main/project/project.component';
import { ProjectModule } from './main/project/project.module';
import { ProfileModule } from './main/profile/profile.module';
import { ComplaintManagementModule } from './main/complaints/complaint-management.module';
import { EmployeeCalendarModule } from './main/calendar/calendar.module';


const appRoutes: Routes = [
    {
        path: '',
        redirectTo: '/welcome',
        pathMatch: 'full'
    },
    {
        path: '**',
        redirectTo: 'welcome'
    }
];

const config = new AuthServiceConfig([
    {
        id: GoogleLoginProvider.PROVIDER_ID,
        provider: new GoogleLoginProvider('245770299387-23hqcb35rtqqoshvuco7urt8t2o29c6u.apps.googleusercontent.com')
    },
    {
        id: FacebookLoginProvider.PROVIDER_ID,
        provider: new FacebookLoginProvider('351372646270395')
    }
]);

export function provideConfig(): any {
    return config;
}

@NgModule({
    declarations: [
        AppComponent
    ],
    imports: [
        BrowserModule,
        BrowserAnimationsModule,
        HttpClientModule,
        RouterModule.forRoot(appRoutes),

        TranslateModule.forRoot(),

        // Material moment date module
        MatMomentDateModule,

        // Material
        MatButtonModule,
        MatIconModule,

        // Fuse modules
        FuseModule.forRoot(fuseConfig),
        FuseProgressBarModule,
        FuseSharedModule,
        FuseSidebarModule,
        FuseThemeOptionsModule,

        // App modules
        LayoutModule,
        SocialLoginModule,

        AuthModule,

        NotificationsManagementModule,
        FaqModule,
        AdsModule,
        ProjectModule,
        RequestManagementModule,
        ComplaintManagementModule,
        RecommenderManagementModule,
        DownloadManagementModule,
        ProfileModule,
        EmployeeCalendarModule,
        SampleModule
    ],
    providers: [
        AuthService,
        AuthGuard,
        RoleGuard,
        { provide: HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true },
        { provide: HTTP_INTERCEPTORS, useClass: TokenInterceptor, multi: true },
        {
            provide: AuthServiceConfig,
            useFactory: provideConfig
        }
    ],
    bootstrap: [
        AppComponent
    ]
})
export class AppModule {
}
